export default {
  foodAllergy: "Food Allergy",
  foodIntolerance: "Food Intolerance",
  eliminateFoods: "Eliminate Foods",
  typeOfOil: "Type Of Oil",
  fastFoods: "Fast Foods",
  fastFoodsPeriodType: "Fast Foods Period",
  carbonatedBeverage: "Carbonated Beverage",
  carbonatedPeriodType: "Carbonated Period",
  caffeinatedBeverage: "Caffeinated Beverage",
  caffeinatedPeriodType: "Caffeinated Period",
  junkFood: "Junk Food",
  junkFoodPeriodType: "Junk Food Period Type",
  otherHabits: "Other Habits",
};
